<form autocomplete="off" [formGroup]="addressDetailsForm">
    <!-- <div *ngIf="fieldType === 'shipper'"> -->

    <div class="row">
        <div class="col-md-4 mb-2">
            <div class="d-flex align-items-center">
                <label for="country" class="form-label">Country <span *ngIf="isCountryMandate"
                        class="mandatory">*</span></label>
                <input type="checkbox" id="country" class="ms-1" [checked]="getCheckedStatus('country')"
                    (change)="toggleFieldCheck('country', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <ng-select #country id="country" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                [items]="countryList" bindLabel="name" [bindValue]="'isocode'" formControlName="ddlCountry"
                (change)="onCountryChange()"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('ddlCountry')?.touched) && addressDetailsForm.get('ddlCountry').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('ddlCountry').valid ? focusNextField('country') : addressDetailsForm.get('ddlCountry').markAsTouched()">
            </ng-select>
            <div *ngIf="(formSubmitted || addressDetailsForm.get('ddlCountry')?.touched) && addressDetailsForm.get('ddlCountry').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('ddlCountry').errors.required">Country is required</span>
            </div>
        </div>
        <div class="col-md-4 mb-2">
            <label for="shippername" class="form-label">Name<span class="mandatory">*</span></label>
            <input #name type="text" class="form-control form-control-sm" id="name" placeholder="Search or Enter Name"
                [resultTemplate]="rt" [inputFormatter]="formatter" formControlName="txtName" [ngbTypeahead]="search"
                (selectItem)="selectedItemEvent($event)"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtName').touched) && addressDetailsForm.get('txtName').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('txtName').valid ? focusNextField('name') : addressDetailsForm.get('txtName').markAsTouched()" />
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtName').touched) && addressDetailsForm.get('txtName').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtName').errors.required">Name is Required</span>
            </div>
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtName').touched) && addressDetailsForm.get('txtName').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtName').errors.maxlength">Name max length is 50 characters</span>
            </div>
            <ng-template #rt let-r="result" let-t="term">
                <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                <span> | {{ r['code'] }}</span>
            </ng-template>
        </div>
        <div class="col-md-4 mb-2">
            <div class="d-flex align-items-center">
                <label for="contactPerson" class="form-label">Contact Person</label>
                <input type="checkbox" id="contactPerson" class="ms-1" [checked]="getCheckedStatus('contactPerson')"
                    (change)="toggleFieldCheck('contactPerson', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <input #contactPerson type="text" class="form-control form-control-sm" id="contactPerson"
                formControlName="txtContactPerson"
                [ngClass]="{'is-invalid':(formSubmitted || addressDetailsForm.get('txtContactPerson').touched) && addressDetailsForm.get('txtContactPerson').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('txtContactPerson').valid ? focusNextField('contactPerson') : addressDetailsForm.get('txtContactPerson').markAsTouched()" />
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtContactPerson').touched) && addressDetailsForm.get('txtContactPerson').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtContactPerson').errors.maxlength">Shipper Contact Person max
                    length is 50 characters</span>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="email" class="form-label">Email</label>
                <input type="checkbox" id="email" class="ms-1" [checked]="getCheckedStatus('email')"
                    (change)="toggleFieldCheck('email', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <input #email type="text" class="form-control form-control-sm" id="email" formControlName="txtEmail"
                [ngClass]="{'is-invalid':(formSubmitted || addressDetailsForm.get('txtEmail').touched) && addressDetailsForm.get('txtEmail').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('txtEmail').valid ? focusNextField('email') : addressDetailsForm.get('txtEmail').markAsTouched()" />
            <div *ngIf="(formSubmitted ||addressDetailsForm.get('txtEmail').touched) && addressDetailsForm.get('txtEmail').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtEmail').errors.pattern">Invalid Email</span>
            </div>
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtEmail').touched) && addressDetailsForm.get('txtEmail').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtEmail').errors.maxlength">Email max length is 150
                    characters</span>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="pincode" class="form-label">Pincode<span *ngIf="addressDetailsForm.get('txtPincode')?.errors?.required" class="mandatory">*</span></label>
                <input type="checkbox" id="pincode" class="ms-1" [checked]="getCheckedStatus('pincode')"
                    (change)="toggleFieldCheck('pincode', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <div class="input-group">
                <input #pincode id="pincode" formControlName="txtPincode" type="text"
                    class="form-control col form-control-sm" placeholder="Type to search" [ngbTypeahead]="searchPincode"
                    [resultTemplate]="pt" [inputFormatter]="pincodeFormatter"
                    (selectItem)="bindAddressByPincode($event)" [minlength]="minPincode" [maxlength]="maxPincode"
                    (keyup)="setPincodeValidation()"
                    [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtPincode')?.touched) && addressDetailsForm.get('txtPincode').errors}"
                    (keydown.enter)="useEnterKey && addressDetailsForm.get('txtPincode').valid ? focusNextField('pincode') : addressDetailsForm.get('txtPincode').markAsTouched()" />
                    <div *ngIf="(formSubmitted || addressDetailsForm.get('txtPincode')?.touched) && addressDetailsForm.get('txtPincode').errors" class="invalid-feedback">
                        <span *ngIf="addressDetailsForm.get('txtPincode').errors.required">Pincode is required.</span>
                        <span *ngIf="addressDetailsForm.get('txtPincode').errors.pattern">Invalid Pincode.</span>
                    </div>
            </div>
            <ng-template #pt let-p="result" let-t="term">
                <ngb-highlight [result]="p.pincode" [term]="t"></ngb-highlight>
                <!-- <span> | {{r['code']}}</span> -->
            </ng-template>
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="state" class="form-label">State<span *ngIf="isStateMandate"
                        class="mandatory">*</span></label>
                <input type="checkbox" id="state" class="ms-1" [checked]="getCheckedStatus('state')"
                    (change)="toggleFieldCheck('state', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <ng-select #state id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                (change)="onStateChange('byLocationChange')" [items]="stateList" bindLabel="name"
                [bindValue]="'isocode'" formControlName="ddlState"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('ddlState')?.touched) && addressDetailsForm.get('ddlState').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('ddlState').valid ? focusNextField('state') : addressDetailsForm.get('ddlState').markAsTouched()">
            </ng-select>
            <div *ngIf="(formSubmitted || addressDetailsForm.get('ddlState')?.touched) && addressDetailsForm.get('ddlState').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('ddlState').errors.required">State is required</span>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="city" class="form-label">City<span *ngIf="isCityMandate" class="mandatory">*</span></label>
                <input type="checkbox" id="city" class="ms-1" [checked]="getCheckedStatus('city')"
                    (change)="toggleFieldCheck('city', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <ng-select #city id="city" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="cityList"
                bindLabel="name" [bindValue]="'isocode'" formControlName="ddlCity"
                (change)="onCityChange()"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('ddlCity')?.touched) && addressDetailsForm.get('ddlCity').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('ddlCity').valid ? focusNextField('city') : addressDetailsForm.get('ddlCity').markAsTouched()">
            </ng-select>
            <div *ngIf="(formSubmitted || addressDetailsForm.get('ddlCity')?.touched) && addressDetailsForm.get('ddlCity').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('ddlCity').errors.required">City is required</span>
            </div>
        </div>
        <div class="col-md-6 mb-2">
            <label for="address1" class="form-label">Address Line 1 <span *ngIf="isAddressMandate"
                    class="mandatory">*</span></label>
            <input #address1 type="text" class="form-control form-control-sm" id="address1"
                formControlName="txtAddress1" maxlength="150"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtAddress1')?.touched) && addressDetailsForm.get('txtAddress1').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('txtAddress1').valid ? focusNextField('address1') : addressDetailsForm.get('txtAddress1').markAsTouched()">
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtAddress1')?.touched) && addressDetailsForm.get('txtAddress1').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtAddress1').errors.required">Address1 is required</span>
            </div>
        </div>
        <div class="col-md-6 mb-2">
            <div class="d-flex align-items-center">
                <label for="address2" class="form-label">Address Line 2 </label>
                <input type="checkbox" id="address2" class="ms-1" [checked]="getCheckedStatus('address2')"
                    (change)="toggleFieldCheck('address2', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <input #address2 id="addresss2" type="text" class="form-control form-control-sm" id="address2"
                formControlName="txtAddress2" maxlength="150"
                (keydown.enter)="useEnterKey && focusNextField('address2')">
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="area" class="form-label">Area<span *ngIf="isAreaMandate" class="mandatory">*</span></label>
                <input type="checkbox" id="area" class="ms-1" [checked]="getCheckedStatus('area')"
                    (change)="toggleFieldCheck('area', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <!-- <input type="text"  placeholder="" maxlength="30" class="form-control form-control-sm" id="area"
                                formControlName="txtArea" [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtArea')?.touched) && addressDetailsForm.get('txtArea').errors}">
                             -->
            <div class="input-group">
                <input #area id="area" formControlName="txtArea" type="text" class="form-control col form-control-sm"
                    placeholder="Type to search" [ngbTypeahead]="searchArea" [resultTemplate]="at" bindLabal="area"
                    [inputFormatter]="areaFormatter" maxlength="30"
                    [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtArea')?.touched) && addressDetailsForm.get('txtArea').errors}"
                    (keydown.enter)="useEnterKey && addressDetailsForm.get('txtArea').valid ? focusNextField('area') : addressDetailsForm.get('txtArea').markAsTouched()" />
                <!-- <div class="input-group-text group-label-sm">
                                    <i class="fas fa-search"></i>
                                </div> -->
                <div *ngIf="(formSubmitted || addressDetailsForm.get('txtArea')?.touched) && addressDetailsForm.get('txtArea').errors"
                    class="invalid-feedback">
                    <span *ngIf="addressDetailsForm.get('txtArea').errors.required">Area is
                        required</span>
                    <span *ngIf="addressDetailsForm.get('txtArea').errors.maxlength">Maximum of 30
                        characters.</span>
                </div>
            </div>
            <ng-template #at let-a="result" let-t="term">
                <ngb-highlight [result]="a.area" [term]="t"></ngb-highlight>
                <!-- <span *ngIf="a.code"> | {{ a.code }}</span>  Only show if 'code' exists -->
            </ng-template>
        </div>
        <div class="col-md-3 mb-2">
            <label for="mobileno" class="form-label">Mobile No.<span *ngIf="addressDetailsForm.get('txtMobileNo').errors?.required"
                    class="mandatory">*</span></label>
            <input type="checkbox" id="mobileNo" class="ms-1" [checked]="getCheckedStatus('mobileNo')"
                (change)="toggleFieldCheck('mobileNo', $event.target.checked)" [hidden]="focusCheckHide">
            <div>
                <input #mobileNo type="number" placeholder="Ex. 0123456789"
                    class="form-control form-control-sm blurred-placeholder" id="mobileNo" formControlName="txtMobileNo"
                    [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtMobileNo')?.touched) && addressDetailsForm.get('txtMobileNo').errors}"
                    appLimitDigits [length]="10"
                    (keydown.enter)="useEnterKey && addressDetailsForm.get('txtMobileNo').valid ? focusNextField('mobileNo') : addressDetailsForm.get('txtMobileNo').markAsTouched()">
                <div *ngIf="(formSubmitted || addressDetailsForm.get('txtMobileNo')?.touched) && addressDetailsForm.get('txtMobileNo').errors"
                    class="invalid-feedback">
                    <span *ngIf="addressDetailsForm.get('txtMobileNo').errors.required">Mobile No. is required</span>
                    <span *ngIf="addressDetailsForm.get('txtMobileNo').errors.pattern">Must be of 10 digits.</span>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
                <label for="telephoneNo" class="form-label">Telephone No.</label>
                <input type="checkbox" id="telephoneNo" class="ms-1" [checked]="getCheckedStatus('telephoneNo')"
                    (change)="toggleFieldCheck('telephoneNo', $event.target.checked)" [hidden]="focusCheckHide">
            </div>
            <input #telephoneNo type="text" placeholder="Ex. 0123456789" class="form-control form-control-sm"
                id="telephoneNo" formControlName="txtTelephoneNo" (change)="onChangeTelephone()"
                (input)="preventChars($event)" appLimitDigits [length]="50"
                [ngClass]="{'is-invalid': (formSubmitted || addressDetailsForm.get('txtTelephoneNo')?.touched) && addressDetailsForm.get('txtTelephoneNo').errors}"
                (keydown.enter)="useEnterKey && addressDetailsForm.get('txtTelephoneNo').valid ? focusEmit.emit() : addressDetailsForm.get('txtTelephoneNo').markAsTouched()">
            <div *ngIf="(formSubmitted || addressDetailsForm.get('txtTelephoneNo')?.touched) && addressDetailsForm.get('txtTelephoneNo').errors"
                class="invalid-feedback">
                <span *ngIf="addressDetailsForm.get('txtTelephoneNo').errors.pattern">Enter a valid number, up to 50
                    characters, separated by commas (if multiple). No special characters between digits.</span>
            </div>
        </div>
    </div>
</form>